import React, { useState } from "react";
import PropTypes from "prop-types";
import ReviewStars from "../ReviewStars";
import DatabaseLink from "./DatabaseLink";
import Btn from "../../../../components/atoms/Btn";
import SubmissionRow from "./SubmissionRow";
import Accession from "../../../../models/Accession";

function AccessionRow({ accession }) {
  const tdClass = "tw-p-1 tw-border tw-border-blueGray-200 tw-text-left";
  const [isSubmissionsVisible, setIsSubmissionsVisible] = useState(false);
  return (
    <>
      <tr>
        <td
          rowSpan={2}
          className={`${tdClass} tw-w-32 tw-text-3xs tw-relative tw-bg-white`}
        >
          <Btn
            className="tw-text-primary tw-text-left tw-px-1"
            onSubmit={() => setIsSubmissionsVisible(!isSubmissionsVisible)}
          >
            <span>{isSubmissionsVisible ? "Hide" : "Show"} </span>
            <span className="tw-pr-0.5">{accession.submissions.length}</span>
            <span>submission{accession.submissions.length > 1 ? "s" : ""}</span>
          </Btn>
        </td>
        <td className={`${tdClass} tw-w-1/4`}>
          {accession.descriptions.join(", ") || "Not found"}
        </td>
        <td className={tdClass}>
          <div>{accession.reviewDate}</div>
          <div>{accession.reviewStatus}</div>
          <ReviewStars stars={accession.reviewStars} />
        </td>
        <td className={tdClass}>
          {accession.significanceArr.join(", ") || "-"}
        </td>
        <td className={tdClass}>{accession.origin}</td>
        <td className={tdClass}>{accession.method}</td>
        <td className={`${tdClass} tw-w-1/6`}>
          {accession.diseaseItems.map((x, i) => (
            <span key={`${new Date().getTime()}-${i}`}>
              <DatabaseLink {...x} />
              {i < accession.diseaseItems.length - 1 ? ", " : ""}
            </span>
          ))}
        </td>
      </tr>
      {isSubmissionsVisible && accession.submissions.length > 0 ? (
        <>
          {accession.submissions.map((x, i) => (
            <SubmissionRow
              tdClass={`${tdClass} `}
              submission={x}
              key={`${new Date().getTime()}-${i}`}
            />
          ))}
        </>
      ) : null}
    </>
  );
}

AccessionRow.propTypes = {
  accession: PropTypes.instanceOf(Accession).isRequired,
};

export default React.memo(AccessionRow);
